import { css as css } from '@emotion/css';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { get_CardHeader3obpaw752sk5t as get_CardHeader } from '../CardHeader.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_PlayerCardHeader() {
  _init_properties_PlayerCardHeader_kt__3n1x9a();
  var tmp = KProperty0();
  return PlayerCardHeader$delegate.getValue_u7qj63_k$(null, getPropertyCallableRef('PlayerCardHeader', 0, tmp, _get_PlayerCardHeader_$ref_3jhj6k(), null));
}
var PlayerCardHeader$delegate;
function PlayerCardHeader$delegate$lambda($this$nfc, props) {
  _init_properties_PlayerCardHeader_kt__3n1x9a();
  setDefaultKey($this$nfc, '@rdk/22_4');
  var tmp2 = get_CardHeader();
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$CardHeader) => {
    $this$CardHeader.size = props.size;
    // Inline function 'emotion.react.css' call
    // Inline function 'emotion.css.ClassName' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_0 = {};
    // Inline function 'web.cssom.TransitionProperty.Companion.all' call
    this_0.transitionProperty = 'all';
    // Inline function 'web.cssom.TransitionTimingFunction.Companion.easeOut' call
    this_0.transitionTimingFunction = 'ease-out';
    // Inline function 'web.cssom.s' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0.transitionDuration = toString(0.4) + 's';
    // Inline function 'csstype.RuleBuilder.invoke' call
    // Inline function 'web.cssom.Selector' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'csstype.RuleBuilder.invoke' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_1 = {};
    // Inline function 'web.cssom.Globals.Companion.inherit' call
    this_1.color = 'inherit';
    // Inline function 'web.cssom.None.Companion.none' call
    this_1.textDecoration = 'none';
    // Inline function 'web.cssom.Display.Companion.block' call
    this_1.display = 'block';
    this_0['a'] = this_1;
    $this$CardHeader.className = css(this_0);
    $this$CardHeader.headerContent = props.player.name_1;
    return Unit_instance;
  };
  addChild($this$nfc, tmp2, block);
  return Unit_instance;
}
function _get_PlayerCardHeader_$ref_3jhj6k() {
  return constructCallableReference(() => get_PlayerCardHeader(), 0, 0, 176);
}
var properties_initialized_PlayerCardHeader_kt_k18qdc;
function _init_properties_PlayerCardHeader_kt__3n1x9a() {
  if (!properties_initialized_PlayerCardHeader_kt_k18qdc) {
    properties_initialized_PlayerCardHeader_kt_k18qdc = true;
    PlayerCardHeader$delegate = nfc(PlayerCardHeader$delegate$lambda);
  }
}
//region block: exports
export {
  get_PlayerCardHeader as get_PlayerCardHeaderzh8h0cgsfjvt,
};
//endregion

//# sourceMappingURL=PlayerCardHeader.mjs.map
